import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_SUBCONTRACTOR} from '../../constants';

export default {
  id: 'FOURN_FAV',
  title: 'Wie kann ich meinen Nachunternehmer zu meinen Favoriten hinzufügen?',
  description: '',
  categories: [CONTENT_CATEGORY_SUBCONTRACTOR],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Führen Sie dazu bitte die folgenden Schritte aus:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Gehen Sie zur Registerkarte "Nachunternehmer".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_FOURN_FAV/DE_FOURN_FAV_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '2.',
    value: 'Klicken Sie auf den Nachunternehmer Ihrer Wahl'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '3.',
    value: 'Klicken Sie oben rechts auf den Stern, um Ihren Nachunternehmer zu den Favoriten hinzuzufügen oder zu entfernen'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_FOURN_FAV/DE_FOURN_FAV_2.png`
  }]
};
